import { render, staticRenderFns } from "./BrowseBuildingKanri.vue?vue&type=template&id=23640442&scoped=true&"
import script from "./BrowseBuildingKanri.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingKanri.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingKanri.vue?vue&type=style&index=0&id=23640442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23640442",
  null
  
)

export default component.exports